import { registerComponent } from "aframe";


export interface AmmoNormalComponent
{
	data : { x : number, y : number, z : number }
};

registerComponent("ammo-normal",  {
	multiple : true,
	schema : { type : "vec3", default : { x:0, y:0, z:0} }
});